import { AvailabilitiesComponent } from './availabilities/availabilities.component';
import { BookingsComponent } from './bookings/bookings.component';
import { CommunicationsComponent } from './communications/communications.component';
import { OperatorsComponent } from './operators/operators.component';
import { RouteReorganizationComponent } from './route-reorganization/route-reorganization.component';
import { ServicesComponent } from './services/services.component';
import { SetupComponent } from './setup/setup.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { TownsComponent } from './towns/towns.component';
import { TripsComponent } from './trips/trips.component';
import { UsersComponent } from './users/users.component';
import { VehiclesComponent } from './vehicles/vehicles.component';

export {
  AvailabilitiesComponent,
  BookingsComponent,
  CommunicationsComponent,
  OperatorsComponent,
  RouteReorganizationComponent,
  ServicesComponent,
  SetupComponent,
  SignInComponent,
  TownsComponent,
  TripsComponent,
  UsersComponent,
  VehiclesComponent,
};

export const pages = [
  AvailabilitiesComponent,
  BookingsComponent,
  CommunicationsComponent,
  OperatorsComponent,
  RouteReorganizationComponent,
  ServicesComponent,
  SetupComponent,
  SignInComponent,
  TownsComponent,
  TripsComponent,
  UsersComponent,
  VehiclesComponent,
]

